enum ValidationLevelType {
  Complete = 1,
  Simple = 2
}

export default ValidationLevelType;
